// src/hooks/hotelRatings/useUpdateHotelRating.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateHotelRating } from "../../api/apiHotelRatings";
import { useNavigate } from "react-router-dom";
import parseError from "../../utils/parseError";

const useUpdateHotelRating = () => {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    const { mutate: editHotelRatings, isPending: isUpdate } = useMutation({
        mutationFn: ({ id, req }) => updateHotelRating(req, id),
        onSuccess: (res) => {
            const message = res?.message || "Hotel rating updated successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRatings"] });
            queryClient.invalidateQueries({ queryKey: ["hotelRating"] });
            navigate("/hotel-ratings");
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to update hotel rating");
        },
    });

    return { editHotelRatings, isUpdate };
};

export default useUpdateHotelRating;
